import { Controller } from "@hotwired/stimulus"

import moment from "moment"
import "daterangepicker/daterangepicker"

export default class extends Controller {
  static targets = ["start", "end", "display"]
  static values = {
    enableTime: { type: Boolean, default: true },
    timeIncrement: { type: Number, default: 30 }
  }

  connect() {
    const format = this.enableTimeValue ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'

    // Define as datas iniciais respeitando o arredondamento se houver tempo
    const start = this.currentStart || this.roundTime(moment())
    const end = this.currentEnd || moment(start).add(1, 'hour')

    const options = {
      timePicker: this.enableTimeValue,
      timePicker24Hour: this.enableTimeValue, // Sincronizado com enableTime
      timePickerIncrement: this.enableTimeValue ? this.timeIncrementValue : 1, // Só incrementa se tiver tempo
      startDate: start,
      endDate: end,
      locale: {
        format: format,
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      }
    }

    $(this.displayTarget).daterangepicker(options, (start, end) => {
      this.updateDates(start, end)
    })

    // Preenche os inputs hidden caso estejam vazios (novo registro)
    if (!this.startTarget.value) this.updateDates(start, end)
  }

  // Função para arredondar o tempo (ex: 14:10 vira 14:30)
  roundTime(date) {
    if (!this.enableTimeValue) return date.startOf('day');

    const duration = moment.duration(this.timeIncrementValue, 'minutes');
    return moment(Math.ceil((+date) / (+duration)) * (+duration));
  }

  updateDates(start, end) {
    const formatStr = this.enableTimeValue ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
    this.startTarget.value = start.format(formatStr)
    this.endTarget.value = end.format(formatStr)

    // Atualiza o texto visual no input de exibição
    const displayFormat = this.enableTimeValue ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'
    this.displayTarget.value = `${start.format(displayFormat)} - ${end.format(displayFormat)}`
  }

  get currentStart() {
    if (this.startTarget.value) {
      return moment(this.startTarget.value, this.enableTimeValue ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD')
    }
    return null
  }

  get currentEnd() {
    if (this.endTarget.value) {
      return moment(this.endTarget.value, this.enableTimeValue ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD')
    }
    return null
  }
}